import { Head } from "@inertiajs/react";

export default function DictionariesIndex() {
  return (
    <>
      <Head>
        <title>Словари</title>
      </Head>

      <div className="table-header">
        <div className="table-header__left">
          <h2>Словари</h2>
        </div>
      </div>

      <table className="tbl">
        <tbody>
          <tr>
            <td>Клиенты</td>
            <td><a href="/admin/dictionaries/clients" className="lnk lnk--blue">Редактировать</a></td>
          </tr>
          <tr>
            <td>Типы проектов</td>
            <td><a href="/admin/dictionaries/project_types" className="lnk lnk--blue">Редактировать</a></td>
          </tr>
          <tr>
            <td>Индустрии</td>
            <td><a href="/admin/dictionaries/industries" className="lnk lnk--blue">Редактировать</a></td>
          </tr>
          <tr>
            <td>Содержимое макета</td>
            <td><a href="/admin/dictionaries/layout_content_types" className="lnk lnk--blue">Редактировать</a></td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
